import { ModalBody, ModalHeader } from 'reactstrap';
import EditFarm from './EditFarm';
import { useFarmSettingsContext } from '../../contexts/FarmSettingsContext';
import Modal from '../basics/Modal';

const FarmSettings = () => {
  const {
    currentFarmSettingsModalId,
    closeFarmSettingsModal,
  } = useFarmSettingsContext();

  return (
    <Modal
      isOpen={!!currentFarmSettingsModalId}
      toggle={closeFarmSettingsModal}
    >
      <ModalHeader
        tag="div"
        toggle={closeFarmSettingsModal}
        className="border-0 pb-0"
      >
        <h2 className="mb-0 mt-1">Project Settings</h2>
      </ModalHeader>
      <ModalBody>
        <EditFarm
          farmId={currentFarmSettingsModalId}
          onCancel={closeFarmSettingsModal}
          onCompleted={closeFarmSettingsModal}
          inModal
        />
      </ModalBody>
    </Modal>
  );
};

export default FarmSettings;
